import CurrentStepActions from './constants';
import { IActionObject } from './types';

const INITIAL_STATE: number = 0;

export default function currentStepReducer(
  state: any = INITIAL_STATE,
  action: IActionObject
): number {
  switch (action.type) {
    case CurrentStepActions.SET_CURRENT_STEP:
      return action.data.currentStep;
    case CurrentStepActions.RESET_CURRENT_STEP:
      return 0;
    default:
      return state;
  }
}
